import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=8f5311e8"
import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports